//https://egghead.io/lessons/javascript-redux-persisting-the-state-to-the-local-storage
export const loadState = (name = "state") => {
  try {
    const serializedState = (localStorage && localStorage.getItem(name)) || null;

    if (serializedState === null || serializedState === undefined || serializedState === "undefined") {
      return undefined;
    }

    return JSON.parse(serializedState);
  }
  catch (error) {
    console.error("Error ao adicionar localStorage:", error);
    return undefined;
  }
};

export const saveState = (state, name = "state") => {
  try {
    const serializedState = JSON.stringify(state);
    if (localStorage) localStorage.setItem(name, serializedState);
  }
  catch (error) {
    console.error("Error ao adicionar localStorage:", error);
  }
};

export const deleteState = (name = "state") => {
  try {
    if (localStorage) localStorage.removeItem(name);
  } catch (error) {
    // Handle any potential errors here
    console.error("Error ao excluir localStorage:", error);
  }
};

export const saveCart = (game, cart, name) => {
  try{
    const gameForSave = {
      game: JSON.stringify(game),
      cart: cart
    }
  
    localStorage.setItem(name, JSON.stringify(gameForSave));
  } catch (error) {
    console.error("Error ao coletar localStorage:", error);
  }

}

export const getSavedCart = (game, name) => {
  try {
    if (localStorage.getItem(name)) {
      const saved = JSON.parse(localStorage.getItem(name));
      const stringCart = JSON.stringify(game);

      if (saved.game === stringCart) {
        return saved.cart;
      } else {
        return false;
      }
    } else return false;

  } catch (error) {
    console.error("Error ao adicionar localStorage:", error);
  }
}

export const removeSavedCart = (name) => {
  try {
    if (localStorage) localStorage.removeItem(name);
  } catch (error) {
    console.error("Error ao excluir localStorage:", error);
  }
}


// WEBPACK FOOTER //
// ./src/modules/localStorage.js